"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "What is your metacognition?",
  placeholder: "Write the thought that you keep thinking about here…",
  tips: "TIPS: These are the payoffs you expect, but they might not be obvious. EG: The payoff for thinking about a negative outcome might be to feel more prepared for it or to work out a solution in case it happens. The payoff for thinking about someone that hurt you might be that you avoid feeling powerless or weak if you stopped being angry at them. ",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "It’s important to keep thinking about this because...",
  placeholder: "Write any reasons why it feels useful to keep thinking about this…",
  tips: "TIPS: These are the payoffs you expect, but they might not be obvious. EG: The payoff for thinking about a negative outcome might be to feel more prepared for it or to work out a solution in case it happens. The payoff for thinking about someone that hurt you might be that you avoid feeling powerless or weak if you stopped being angry at them.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "The cost of thinking like this is….",
  placeholder: "Write the negative impact that your thinking is having here...",
  tips: "TIPS: How does it affect the way you feel? The way you act? The way you treat yourself or others? How does it affect your self-esteem? Is the payoff you get worth the cost of thinking this way?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Who is someone you are grateful for that can you shift your attention to?",
  placeholder: "Write the name of someone here and the reasons why you are grateful for them...",
  tips: "TIPS: We use this step to help break out of an unhelpful thinking pattern. If you recognise that the costs are not worth the payoff, shift your attention to gratitude retrain your mindset over time.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the next thought you need to retrain?",
  placeholder: "Write down any reasons why it still feels important to think about this...",
  tips: "TIPS: It sometimes helps to question the payoffs that you’ve identified. They might be reasons that you’ve never examined closely. Write them down then come back and examine whether the payoff thought is really true at all.",
  type: "multirow",
  aggregated: true
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 4),
    rootThought: answers[4]
  };
}

;